<template>
    <!-- 折线图图表 -->
    <div :id="id" :style="{height:height}" />
</template>

<script>
import resize from './resize.js'
export default {
    name:"yl-lc-echarts-line",
    mixins: [resize],
    props: {
        chartData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        id: {
            type: String,
            default: new Date().getTime()
        },
        height: {
            type: String,
            default: '400px'
        }
    },
    data() {
        return {
            chart: null,
            initData: null
        }
    },
    mounted() {
        this.chart = this.echarts.init(document.getElementById(this.id))
        this.initChart()
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            let _this = this
            this.initData = null
            this.initData = {
                // 标题
                title: {
                    text: this.chartData.titleText ? this.chartData.titleText : ""
                },
                // 移入提示框
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    borderColor: "#ffffff"
                },
                // tooltip: {
                //     trigger: 'axis'
                // },
                // 图例组件
                // legend: {
                //     data:['邮件营销', '联盟广告', '视频广告']
                // },
                grid: this.chartData.grid || {},
                xAxis: this.chartData.xAxis,
                yAxis: this.chartData.yAxis,
				series: [
                    // {
                    //     // 折线名称描述
                    //     // name: '占比 %',
                    //     type: 'line',
                    //     // 是否平滑
                    //     smooth: this.chartData.smooth || false,
                    //     // data: [150, 230, 224, 218, 135, 147, 260],
                    //     data: this.chartData.seriesData || [],
                    //     // 折线颜色
                    //     itemStyle:{
                    //         //通常情况下：
                    //         normal:{
                    //             color: '#34C0B7',
                    //         },
                    //         //鼠标悬停时：
                    //         // emphasis: {
                    //         //     shadowBlur: 10,
                    //         //     shadowOffsetX: 0,
                    //         //     shadowColor: 'rgba(0, 0, 0, 0.5)'
                    //         // }
                    //     }
                    // }
                ]
            }

            if(this.chartData.seriesJson){
                // 图例组件
                this.initData.legend=this.chartData.legend || {};
                //Object.assign();
                // this.initData.legend = {
                //     data: this.chartData.seriesJson.map(item =>{return item.name})
                // }
                this.initData.series = this.chartData.seriesJson.map(item =>{
                    let setEchartsData = this.chartData.setEchartsData
                    let obj = {
                        ...item,
                        // name: item.name,
                        //name: setEchartsData && setEchartsData.setSeriesName ? item[setEchartsData.setSeriesName] : item.name,
						// 图类 line为折线图 bar为柱状图
                        type: item.type || "line",
						// 折线图数据
                        // data: item.data,
                        data: setEchartsData && setEchartsData.setSeriesData ? item[setEchartsData.setSeriesData] : item.data,
                    }
                    if(item.xAxisIndex){
                        obj.xAxisIndex = item.xAxisIndex
                    }
                    if(item.yAxisIndex){
                        obj.yAxisIndex = item.yAxisIndex
                    }
                    if(item.stack){
						// 折线图是否需要堆叠方式 (数据堆叠:同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加)
                        obj.stack = item.stack
                    }
                    // 折线图阴影
                    if(this.chartData.serieAareaStyle){
                        obj.areaStyle = {
                            // 阴影颜色透明度
                            // opacity: 0.3,
                            // color: new $echarts.graphic.linearGradient(0,0,0,1,[ //折线图阴影区域渐变色（offset为偏移量，即从0-1颜色变化）
                            //     {offset:0,color:'rgba(0,255,255,0.8)'},
                            //     {offset:1,color:'rgba(0,0,0,0)'}
                            // ])
                            // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            //     offset: 0,
                            //     color: 'rgba(58,77,233,0.8)'
                            // }, {
                            //     offset: 1,
                            //     color: 'rgba(58,77,233,0.3)'
                            // }])
                        }
                    }
                    return obj
                })
            }
            // 清除画布
            this.chart.clear()
            this.chart.setOption(this.initData)
        },
        // 更新处理最新echarts数据
        setEchartOption(){
            this.initChart()
        }
    }
}
</script>